import { Directive, HostBinding, input } from '@angular/core';
import { MatRipple } from '@angular/material/core';

export type TFlatButtonShape = 'rounded' | 'square';
export type TFlatButtonStyle = 'primary' | 'secondary' | 'danger' | 'cancel' | 'border-primary' | 'border-green' | 'border-secondary';

@Directive({
  selector: '[appFlatButton]',
  standalone: true,
  // MatRippleをインポートに追加
  providers: [MatRipple],
  // ホスト属性としてMatRippleを追加
  hostDirectives: [
    {
      directive: MatRipple,
      inputs: ['matRippleDisabled: disabled'],
    },
  ],
})
export class FlatButtonDirective {
  flatButtonStyle = input<TFlatButtonStyle>('primary');
  flatButtonShape = input<TFlatButtonShape>('rounded');
  disabled = input<boolean>(false);

  getShapeStyle() {
    switch (this.flatButtonShape()) {
      case 'rounded':
        return ['tw-rounded-full'];
      case 'square':
        return ['tw-rounded-md'];
      default:
        throw new Error('Invalid flat button shape');
    }
  }

  @HostBinding('class')
  get elementClass(): string {
    const commonStyles = [
      'tw-relative tw-overflow-hidden',
      'tw-justify-center tw-inline-flex tw-items-center',
      'tw-py-2 tw-px-6 tw-outline-none',
    ];
    const shapeStyle = this.getShapeStyle();

    // 背景オレンジ文字白
    const primaryStyles = ['tw-bg-primary hover:tw-opacity-90 tw-text-white'];

    // 背景青文字白
    const secondaryStyles = ['tw-bg-secondary hover:tw-opacity-90 tw-text-white'];

    // 背景赤文字白
    const dangerStyles = ['tw-bg-red-600 hover:tw-bg-red-500 tw-text-white'];

    // 背景グレー文字グレー
    const disabledStyles = ['tw-text-primary tw-bg-gray-300 tw-text-gray-500 tw-cursor-not-allowed'];

    // 背景白文字青ボーダー
    const cancelStyles = ['tw-border-[1px] hover:tw-bg-gray-100 tw-border-solid tw-border-zinc-200'];

    // 背景白文字オレンジボーダー
    const borderPrimary = ['tw-border-[1px] hover:tw-bg-gray-100 tw-border-solid tw-border-primary tw-text-primary'];

    // 背景白文字グリーンボーダー
    const borderGreen = ['tw-border-[1px] hover:tw-bg-gray-100 tw-border-solid tw-border-tealgreen tw-text-tealgreen'];

    // 背景白文字青ボーダー
    const borderSecondary = ['tw-border-[1px] hover:tw-bg-gray-100 tw-border-solid tw-border-secondary tw-text-secondary'];

    if (this.disabled()) {
      return [...commonStyles, ...shapeStyle, ...disabledStyles].join(' ');
    }

    switch (this.flatButtonStyle()) {
      case 'primary':
        return [...commonStyles, ...shapeStyle, ...primaryStyles].join(' ');
      case 'secondary':
        return [...commonStyles, ...shapeStyle, ...secondaryStyles].join(' ');
      case 'danger':
        return [...commonStyles, ...shapeStyle, ...dangerStyles].join(' ');
      case 'cancel':
        return [...commonStyles, ...shapeStyle, ...cancelStyles].join(' ');
      case 'border-primary':
        return [...commonStyles, ...shapeStyle, ...borderPrimary].join(' ');
      case 'border-green':
        return [...commonStyles, ...shapeStyle, ...borderGreen].join(' ');
      case 'border-secondary':
        return [...commonStyles, ...shapeStyle, ...borderSecondary].join(' ');
      default:
        throw new Error('Invalid flat button style');
    }
  }
}
